module.exports = __webpack_public_path__ + "static/media/mktools.03fbe0b8.svg";